import { gql } from '@apollo/client';

const OPERATION_LOG_LISTING_FIELDS = gql`
    fragment OperationLogListingFields on SystemOperationLogListingResponseType {
        content {
            id
            bizType
            bizTypeName
            bizId
            operationType
            operationTypeName
            operatorId
            operatorName
            operatedAt
            changesJson
            metadataJson
            isEncrypted
            description
            createdAt
            updatedAt
        }
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
    }
`;

// DSP 入口
export const GET_ACCOUNT_DELIVERY_DRIVER_OPERATION_LOGS = gql`
    query GetAccountDeliveryDriverOperationLogs($accountId: Long!, $pageRequest: PageRequestTypeInput) {
        getAccountDeliveryDriverOperationLogs(accountId: $accountId, pageRequest: $pageRequest) {
            ...OperationLogListingFields
        }
    }
    ${OPERATION_LOG_LISTING_FIELDS}
`;

// 总部入口：返回字段别名统一为 getAccountDeliveryDriverOperationLogs，共用响应类型
export const GET_ACCOUNT_DELIVERY_DRIVER_OPERATION_LOGS_FOR_CENTRAL = gql`
    query GetAccountDeliveryDriverOperationLogsForCentral($accountId: Long!, $pageRequest: PageRequestTypeInput) {
        getAccountDeliveryDriverOperationLogs: getAccountDeliveryDriverOperationLogsForCentral(accountId: $accountId, pageRequest: $pageRequest) {
            ...OperationLogListingFields
        }
    }
    ${OPERATION_LOG_LISTING_FIELDS}
`;

// 仓库入口：需传当前仓库ID
export const GET_ACCOUNT_DELIVERY_DRIVER_OPERATION_LOGS_FOR_WMS = gql`
    query GetAccountDeliveryDriverOperationLogsForWms($accountId: Long!, $warehouseId: Long!, $pageRequest: PageRequestTypeInput) {
        getAccountDeliveryDriverOperationLogs: getAccountDeliveryDriverOperationLogsForWms(accountId: $accountId, warehouseId: $warehouseId, pageRequest: $pageRequest) {
            ...OperationLogListingFields
        }
    }
    ${OPERATION_LOG_LISTING_FIELDS}
`;

export interface SystemOperationLogType {
    id: number | null;
    bizType: number;
    bizTypeName: string;
    bizId: string;
    operationType: number;
    operationTypeName: string;
    operatorId: number | null;
    operatorName: string | null;
    operatedAt: number;
    changesJson: string | null;
    metadataJson: string | null;
    isEncrypted: boolean;
    description: string | null;
    createdAt: number;
    updatedAt: number;
}

export interface GetAccountDeliveryDriverOperationLogsResponse {
    getAccountDeliveryDriverOperationLogs: {
        content: SystemOperationLogType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetAccountDeliveryDriverOperationLogsVariables {
    accountId: number;
    warehouseId?: number;
    pageRequest?: {
        page?: number;
        size?: number;
    };
}

